import MasterTab from 'src/components/Layouts/MasterTab.vue';
import IndividualProgressSheet from "src/views/Pages/Dashboard/Grow/Reports/HIP/IndividualProgressSheet.vue";
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';

const IndividualProgressSheetRoutes = {
  path: 'grow',
  name: 'grow.grow',
  component: MasterTab,
  props: { reference: 'growTabs' },
  children: [
    {
      path: 'hipreport',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'grow.hip_report',
          component: IndividualProgressSheet,
          meta: {
            prefix_permission: 'grow_hipreport',
          },
        },
      ],
    },
  ],
};

export default IndividualProgressSheetRoutes;